"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverHeader: function() {
        return _index.TeachingPopoverHeader;
    },
    renderTeachingPopoverHeader_unstable: function() {
        return _index.renderTeachingPopoverHeader_unstable;
    },
    teachingPopoverHeaderClassNames: function() {
        return _index.teachingPopoverHeaderClassNames;
    },
    useTeachingPopoverHeaderStyles_unstable: function() {
        return _index.useTeachingPopoverHeaderStyles_unstable;
    },
    useTeachingPopoverHeader_unstable: function() {
        return _index.useTeachingPopoverHeader_unstable;
    }
});
const _index = require("./components/TeachingPopoverHeader/index");
